<template>
	<div class="custom-product-summary">
		<!-- PRODUCT SUMMARY TITLE / NAME SECTION -->
		<div class="summary-section">
			<div class="summary-title">Summary</div>
			<div class="summary-subtitle">{{ product.name }}</div>
		</div>

		<!-- DETAILS -->
		<div class="summary-section">
			<div class="summary-detail-line">
				<span class="detail-name">Size</span>
				<span class="detail-value">{{ sizeDisplay }}</span>
			</div>

			<div class="summary-detail-line">
				<span class="detail-name">Room</span>
				<span class="detail-value">{{ cartItem.room }}</span>
			</div>

			<div class="summary-detail-line">
				<span class="detail-name">Control Position</span>
				<span class="detail-value">{{ controlPos | capitalize }}</span>
			</div>

			<div class="summary-detail-line">
				<span class="detail-name">Mount Position</span>
				<span class="detail-value">{{ cartItem.mountPos | capitalize }}</span>
			</div>


			<!-- HEADRAIL -->
			<!--
			<div class="summary-detail-line">
				<span class="detail-name">Headrails</span>
				<span class="detail-value">
					{{ headrails.count > 1 ? headrailSizes : 'Standard '}}
				</span>
			</div>
			-->

			<!-- OPTIONS SELECTED -->
			<div v-for="opt in selectedOptionList" :key="opt.id" class="summary-detail-line">
				<span class="detail-name">{{ optionTypes[opt.product_option_type_id].type_name }}</span>
				<span class="detail-value">{{ opt.name }}</span>
				<span v-if="getOptionPrice(opt.id) > 0" class="detail-amount">{{ getOptionPrice(opt.id) | currency }}</span>
			</div>
		</div>

		<!-- QUANTITY / ITEM PRICE -->
		<div class="summary-section">
			<div class="row align-center justify-space-between">
				<div class="col-sm-4 col-xs-6">Qty</div>
				<div class="col-sm-4 col-xs-6">{{ getProductPrice | currency }}</div>
				<div class="col-sm-4 col-xs-12">
					<input type="text" class="ux-control" :value="cartItem.qty" @input="updateCartItem({ qty: $event.target.value })">
				</div>
			</div>
		</div>

		<div class="summary-section" :class="{ 'is-loading': loading }">
			<div class="summary-amount-line">
				<span class="amount-label">Item Price</span>
				<span class="amount-value">{{ summary.product_price | currency }}</span>
			</div>

			<!--
			<div class="summary-amount-line is-savings">
				<span class="amount-label">Savings</span>
				<span class="amount-value">{{ summaryAmounts.discounted | currency }}</span>
			</div>
			-->

			<template v-if="summary.discounts">
				<div v-for="disc in summary.discounts" :key="disc.id" class="summary-amount-line is-discount">
					<span class="amount-label">{{ disc.name }}</span>
					<span class="amount-value">
						<template v-if="disc.deduct_type == 'percentage'">{{ disc.deduct_amount }}% off!</template>
						<template v-else-if="disc.deduct_type == 'flat'">{{ disc.deduct_amount | currency }} off!</template>
					</span>
				</div>

				<div class="summary-amount-line is-total">
					<span class="amount-label">Total</span>
					<span class="amount-value">
						<span class="original-total">{{ summary.total | currency }}</span>
						{{ summary.discounted_total | currency }}
					</span>
				</div>
			</template>

			<template v-else>
				<div class="summary-amount-line is-total">
					<span class="amount-label">Total</span>
					<span class="amount-value">{{ summary.total | currency }}</span>
				</div>
			</template>

			<template v-if="saving">
				<ux-btn disabled block color="primary" icon-left="fas fa-spin fa-circle-notch">Please wait</ux-btn>
			</template>

			<template v-else>
				<ux-btn block color="primary" icon-left="fas fa-cart-plus" class="mb-2" :disabled="loading" @click="addToCart">Add To Cart</ux-btn>
				<ux-btn block color="outline-primary" :disabled="loading" @click.prevent="continueBrowsing">Continue Browsing</ux-btn>
			</template>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

import filters from 'common/filters';

export default {
	mixins: [filters],

	inject: ['validateProduct'],

	data() {
		return {
			saving: false,
		}
	},

	computed: {
		...mapGetters('customizer', ['selectedOptionList', 'getProductPrice', 'getOptionPrice']),
		...mapGetters('shell', ['productOptionTypeList']),
		...mapState({
			optionTypes: state => state.shell.productOptionTypes,
			product: state => state.customizer.product,
			cartItem: state => state.customizer.cartItem,
			optionSelections: state => state.customizer.optionSelections,
			options: state => state.customizer.options,
			summary: state => state.customizer.summary,
			loadingIndicators: state => state.customizer.loading,
			controlPos: state => state.customizer.headrailControls,
			/*headrails: state => ({
				count: state.customizer.headrailNum,
				controls: state.customizer.headrailControls,
				sizes: state.customizer.headrailSizes,
			})*/
		}),

		/*headrailSizes()
		{
			var parts = [];

			for(var i=0; i<this.headrails.count; i++)
				parts[i] = filters.filters.sizeDisplay(this.headrails.sizes[i]);

			return parts.join(', ');
		},*/

		loading() 
		{
			return this.loadingIndicators.summary;
		},

		sizeDisplay()
		{
			var width = this.cartItem.width.whole;
			var height = this.cartItem.height.whole;

			if (this.cartItem.width.fractional != '0')
				width += ` ${this.cartItem.width.fractional}`;

			if (this.cartItem.height.fractional != '0')
				height += ` ${this.cartItem.height.fractional}`;

			return `${width}" × ${height}"`
		},

		summaryAmounts()
		{
			var result = {
				subtotal: 0,
				discounted: 0,
				total: 0,
			};

			return result;
		},

	},

	methods: {
		...mapActions('customizer', ['addItemToCart']),
		...mapMutations('customizer', ['updateCartItem']),

		getSelectedOptionNames(typeId)
		{
			var selected = this.optionSelections[typeId] || [];
			return selected.map(id => this.options[id].name).join(', ');
		},

		continueBrowsing()
		{
			document.location='/categories';
		},

		async addToCart()
		{
			if (!await this.validateProduct())
				return;

			this.saving = true;

			try
			{
				await this.addItemToCart();

				this.$router.push('/cart');
			}
			finally
			{
				this.saving = false;
			}
		}
	}
}
</script>